import cc from 'classcat';

import { fromCents } from '#src/lib/formatters/numbers';
import BorderedRow from '#src/components/BorderedRow';
import { CloudinaryImage } from '#src/components/CloudinaryImage';
import GameStats from '#src/components/GameStats';
import GameDateRange from '#src/components/GameDateRange';
import { gamePotAmount, gamePlayerCount } from '#src/lib/game-utils/game-stats';

import PaymentPlanChoice from './PaymentPlanChoice';
import { GameDescription } from './GameDescription';
import styles from './styles.module.scss';
import { isFeeGamePaymentPlan } from './helpers/is-fee-game-payment-plan.js';

const GameItem = ({
  amount,
  content: { betAmountLabel, gameFeeLabel = 'Game Entry Fee' },
  game,
  game: {
    type,
    title,
    image,
    betAmount,
    payoutPercentage,
    pledgedAmount,
    description,
    shortDescription,
    duration,
    startDate,
    endDate,
  },
  paymentPlan,
  paymentPlanChoices,
  className,
  onPlanSelection,
  theme,
}) => {
  const amountLabel = isFeeGamePaymentPlan(paymentPlan)
    ? gameFeeLabel
    : betAmountLabel;
  const handlePlanSelection = ({ code, amount }) =>
    onPlanSelection({ gameType: game.type, gameId: game.id, code, amount });
  const displayPlans = paymentPlanChoices?.length > 1;
  const hideBetCopy = payoutPercentage == 0;
  const plans = displayPlans && (
    <div className={styles.plans}>
      {paymentPlanChoices.map((plan) => (
        <PaymentPlanChoice
          key={plan.code}
          name="paymentPlan"
          {...plan}
          selected={paymentPlan == plan.code}
          theme={type}
          onChange={handlePlanSelection}
        />
      ))}
    </div>
  );

  return (
    <BorderedRow className={cc([styles.container, className])}>
      <div className={styles.media}>
        <>
          <CloudinaryImage
            image={image}
            crop="fill"
            className={cc([styles.image, styles.smallImage])}
          />
          <CloudinaryImage
            image={image}
            crop="fill"
            width={260}
            height={260}
            className={cc([styles.image, styles.largeImage])}
          />
        </>
      </div>
      <div className={styles.details}>
        <h2 className={styles.title}>{title}</h2>
        <GameDescription
          theme={theme}
          title={title}
          description={shortDescription || description}
        />
        {!hideBetCopy && (
          <GameStats
            theme={theme}
            bet={betAmount}
            pot={gamePotAmount(game)}
            pledged={pledgedAmount}
            players={gamePlayerCount(game)}
            className={styles.stats}
          />
        )}
        <GameDateRange
          duration={duration}
          start={startDate}
          end={endDate}
          className={styles.dates}
        />
        {plans}
      </div>
      {plans}
      {!displayPlans && !hideBetCopy && (
        <div className={styles.bet}>
          <span>
            {amountLabel}: <strong>{fromCents(amount)}</strong>
          </span>
        </div>
      )}
    </BorderedRow>
  );
};

export default GameItem;
